import { cn } from '../lib/cn';

export interface ApiProblem {
  type: string; title: string; status: number;
  detail?: string; instance?: string; code?: string;
}

export function ApiError({ problem, className }: { problem: ApiProblem; className?: string }) {
  return (
    <div role="alert" className={cn('rounded border border-accent/40 bg-accent/10 p-4', className)}>
      <p className="font-semibold text-ink">{problem.title}</p>
      {problem.detail && <p className="text-sm text-ink/80">{problem.detail}</p>}
      {problem.instance && (
        <div className="mt-2 flex items-center gap-2 text-xs text-ink/60">
          <code>{problem.instance}</code>
          <button
            type="button"
            className="rounded bg-primary px-2 py-0.5 text-white"
            onClick={() => void navigator.clipboard.writeText(problem.instance!)}
          >
            Copy id
          </button>
        </div>
      )}
    </div>
  );
}
